import fetcher from 'api/fetcher';
import { NotificationName } from 'utils/constants/notification';

import { setBannerDefaultText } from 'store/models/bannerTextGeneration';
import {
    QuickCampaignFieldName,
    setQuickCampaignFieldByName,
    setQuickCampaignProfRoles,
    setQuickCampaignVacancyName,
} from 'store/models/createQuickCampaign';
import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

interface InfoFromVacancy {
    title: string;
    text: string;
    profRoleIds: number[];
}

export const fetchInfoFromVacancy = (vacancyId: string): AppThunkAction => {
    return (dispatch) => {
        return fetcher
            .get<unknown, InfoFromVacancy>(`/api/v1/vacancy/campaign_info_from_vacancy?vacancyId=${vacancyId}`)
            .then((infoFromVacancy) => {
                const { title, text, profRoleIds } = infoFromVacancy;
                dispatch([
                    setQuickCampaignFieldByName({ fieldName: QuickCampaignFieldName.VacancyId, value: vacancyId }),
                    setQuickCampaignFieldByName({ fieldName: QuickCampaignFieldName.Title, value: title }),
                    setQuickCampaignFieldByName({ fieldName: QuickCampaignFieldName.Text, value: text }),
                    setQuickCampaignProfRoles(profRoleIds.map(String)),
                    setQuickCampaignVacancyName(title),
                    setBannerDefaultText(text),
                ]);
            })
            .catch(() => {
                dispatch(addNotification(NotificationName.SomethingWentWrong));
            });
    };
};
